export default __webpack_public_path__ + "static/media/ImageMCQ.2658aecb.png";